import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from '@/i18n'

import Checkbox from '@/Common/NewForm/Checkbox'
import * as ColorHelper from '@/utils/ColorHelper'
import { GetStyleTemplateCategory } from '@/utils/Global'
import DropdownV2 from '@/Common/DropdownV2'

import './index.scss'

class NewCategory extends Component {
    recommendTags = {
        ko: [
            "#홍보",
            "#소개",
            "#유튜브",
            "#감성",
            "#심플",
            "#이벤트",
            "#프로모션",
            "#결혼",
            "#생일",
            "#교육",
            "#여행",
            "#인트로",
            "#Vlog",
            "#게임",
            "#편지",
        ],
        en: [
            "#Event",
            "#Bright",
            "#Promotion",
            "#Simple",
            "#Travel",
            "#Vlog",
            "#Cafe",
            "#Beauty"
        ],
        jp: [
            "#イベント",
            "#広報",
            "#シンプル",
            "#イラスト",
            "#広告",
            "#プロモーション",
            "#紹介",
            "#キュート"
        ]
    }

    constructor(props) {
        super(props)
        this.state = {
            isExpandFilter: props.isExpandOnInit,
            itemWidth: 140,
            sortLabel: i18n.t("web.designselect.newfilter.items.sort.new")
        }
    }

    componentDidMount() {
        this.calculateItemWidth()
        document.addEventListener('click', this.handleOutsideClick)
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.lang !== nextProps.lang) {
            this.calculateItemWidth()
        }
    }

    calculateItemWidth = () => {
        const el = document.createElement('span')
        el.style.position = 'absolute'
        el.style.left = '-10000px'
        el.style.top = '-10000px'
        el.style.fontSize = '15px'
        document.body.appendChild(el)

        const labels = [
            ...this.getStyleFilterItems().map(item => item.label)
        ]

        let maxWidth = 0
        labels.forEach(label => {
            el.innerText = label
            const { width } = el.getBoundingClientRect()
            maxWidth = Math.max(maxWidth, width)
        })

        document.body.removeChild(el)

        this.setState({
            itemWidth: Math.max(140, maxWidth + 60)
        })
    }

    handleKeyPressSearchString = e => {
        const { handleClickSearchBtn } = this.props
        
        if (e.key === "Enter") {
            handleClickSearchBtn()
        }
    }

    getStyleFilterItems = () => {
        const STYLE_TEMPLATE_CATEGORY = GetStyleTemplateCategory()
        return [
            STYLE_TEMPLATE_CATEGORY.Dynamic,
            STYLE_TEMPLATE_CATEGORY.Cheerful,
            STYLE_TEMPLATE_CATEGORY.Sentimental,
            STYLE_TEMPLATE_CATEGORY.Simple,
            STYLE_TEMPLATE_CATEGORY.Vintage,
            STYLE_TEMPLATE_CATEGORY.BlackWhite,
            STYLE_TEMPLATE_CATEGORY.Colorful,
            STYLE_TEMPLATE_CATEGORY.Cute,
            STYLE_TEMPLATE_CATEGORY.Season,
            STYLE_TEMPLATE_CATEGORY.SubtitleBased
        ]
    }

    getSortItemsV2 = () => {
        return [
            {
                value: "new",
                label: i18n.t("web.designselect.newfilter.items.sort.new"),
                icon: null
            },
            {
                value: "hot",
                label: i18n.t("web.designselect.newfilter.items.sort.hot"),
                icon: null
            }
        ]
    }

    getSortItems = () => {
        const items = [
            {
                title: i18n.t("web.designselect.newfilter.label.sort"),
                type: "default",
                filterName: 'sort',
                items: [
                    { label: i18n.t("web.designselect.newfilter.items.sort.new"), key: "new" },
                    { label: i18n.t("web.designselect.newfilter.items.sort.hot"), key: "hot" }
                ]
            }
        ]
        return items
    }

    getFilterItems = () => {
        const { filter: { isShowEditableOnly }, handleChangeFilter, lang } = this.props
        const items = [
            {
                title: i18n.t("web.designselect.newfilter.label.style"),
                type: "default",
                filterName: 'styleCategory',
                items: this.getStyleFilterItems()
            },
            {
                title: i18n.t("web.designselect.newfilter.label.length"),
                type: "default",
                filterName: 'lengthFilter',
                items: [
                    { label: "0\" ~10\"", key: "0-10" },
                    { label: "10\" ~ 15\"", key: "10-15" },
                    { label: "15\" ~ 20\"", key: "15-20" },
                    { label: "20\" ~ 25\"", key: "20-25" },
                    { label: "25\" ~ 30\"", key: "25-30" },
                    { label: "30\" ~", key: "30-" }
                ]
            },
            {
                title: i18n.t("web.designselect.newfilter.label.images"),
                type: "default",
                filterName: 'imageCountFilter',
                items: [
                    { label: i18n.t("web.designselect.newfilter.items.images.0-0"), key: "0-0" },
                    { label: i18n.t("web.designselect.newfilter.items.images.0-5"), key: "1-5" },
                    { label: i18n.t("web.designselect.newfilter.items.images.5-10"), key: "5-10" },
                    { label: i18n.t("web.designselect.newfilter.items.images.10-15"), key: "10-15" },
                    { label: i18n.t("web.designselect.newfilter.items.images.15-"), key: "15-" },
                ]
            },
            {
                title: i18n.t("web.designselect.newfilter.label.color"),
                type: "color",
                filterName: 'colorFilter',
                items: ColorHelper.GetTemplateColor()
            },
            {
                title: i18n.t("web.designselect.newfilter.label.sort"),
                type: "default",
                filterName: 'sort',
                items: [],
                customItems: (
                    <div className="item check-editable">
                        <Checkbox
                            id={'check-editable'}
                            checked={isShowEditableOnly}
                            onChange={e => handleChangeFilter({ name: 'isShowEditableOnly', value: e.target.checked })}
                        />
                        <label for='check-editable'>
                            {i18n.t("web.designselect.newfilter.items.sort.editable")}
                        </label>
                    </div>
                )
            },
            {
                title: i18n.t("web.designselect.newfilter.label.hashtag"),
                type: "hashtag",
                filterName: 'searchString',
                items: this.recommendTags[lang] || this.recommendTags['en']
            }
        ]

        return items
    }

    renderItems = item => {
        const { type, filterName, items } = item
        const {
            filter,
            handleChangeFilter,
            handleChangeSearchString,
            handleClickSearchBtn
        } = this.props
        const { itemWidth } = this.state

        switch (type) {
            case 'color': return items.map(({ key, code, css }) => {
                const onClickHandler = () => handleChangeFilter({
                    name: filterName,
                    key
                })
                const isActive = filter[filterName] && filter[filterName][key]

                let style

                if (css) style = css
                else style = { background: code }

                return (
                    <div
                        className={`item ${(key === 'white' || key === 'pattern') && 'white-border'} ${isActive && 'active'}`}
                        style={style}
                        onClick={onClickHandler}
                    />
                )
            })
            case 'hashtag': return (
                <>
                    <div className="hashtag-input">
                        <input
                            value={filter.searchString}
                            onChange={handleChangeSearchString}
                            onKeyPress={this.handleKeyPressSearchString}
                            placeholder={i18n.t("web.designselect.newfilter.items.hashtag.input.placeholder")}
                        />
                        <img
                            src="https://front.videomonster.com/images-u6yd72dy/web/blacksearch.png"
                            alt=""
                            onClick={() => handleClickSearchBtn()}
                        />
                    </div>
                    <div className="hashtag-list-wrapper">
                        <span className="label">
                            {i18n.t("web.designselect.newfilter.items.hashtag.label")}
                        </span>
                        {
                            items.map(item => (
                                <span
                                    className="item"
                                    onClick={() => handleChangeFilter({
                                        name: filterName,
                                        value: item
                                    })}
                                >
                                    {item}
                                </span>
                            ))
                        }
                    </div>
                </>
            )

            default:
                return items.map(item => {
                    const { label, key } = item

                    const onClickHandler = () => handleChangeFilter({
                        name: filterName,
                        key
                    })
                    const isActive = filter[filterName] && filter[filterName][key]

                    return (
                        <div
                            className={`item ${isActive && 'active'}`}
                            style={{ width: itemWidth }}
                        >
                            <span onClick={onClickHandler}>{label}</span>
                            {
                                isActive &&
                                <div className="x-box" onClick={onClickHandler}>
                                    <div className="line1" />
                                    <div className="line2" />
                                </div>
                            }
                        </div>
                    )
                })
        }
    }

    render() {
        const { isExpandFilter, sortLabel } = this.state
        const { handleChangeFilter } = this.props
        const filterItems = this.getFilterItems()
        const sortItems = this.getSortItems()
        return (
            <div className="new-category-root-container">
                <div className='new-category-btn-area'>
                    <div className="icon-wrapper" onClick={() => this.setState({ isExpandFilter: !isExpandFilter })}>
                        <div className='filter-icon'>
                            <span>{i18n.t("web.designselect.search.filter")}</span>
                            <img src="https://front.videomonster.com/images-u6yd72dy/web/category/filter2.svg" alt="" />
                        </div>
                    </div>
                    <DropdownV2
                        options={this.getSortItemsV2()}
                        selectedOption={this.getSortItemsV2().find(item => item.label === sortLabel)}
                        onSelect={option => {
                            handleChangeFilter({ name: 'sort', key: option.value })
                            this.setState({ sortLabel: option.label })
                        }}
                    />
                </div>
                {
                    isExpandFilter
                        ?
                        <div className="filter-container">
                            {
                                filterItems.map(item => {
                                    const { title, type, customItems, filterName } = item
                                    return (
                                        <div className={`item-wrapper ${filterName}`}>
                                            <div className="title">
                                                <span>{title}</span>
                                                <div className="right-line" />
                                            </div>
                                            <div className={`items ${type}`}>
                                                {this.renderItems(item)}
                                                {customItems}
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(NewCategory)